import {
  Module,
  VuexModule,
  Action,
  Mutation,
  MutationAction
} from "vuex-module-decorators";
import { RootState } from "@/store";
import {
  couponExchange,
  queryExchangeCouponPage,
  checkValidity,
  queryByCouponCode
} from "@/graphql/coupon.gql";
import { queryRequest } from "@/utils/request";

export interface CouponRedeemState {}

@Module({ name: "CouponRedeem", namespaced: true })
export default class CouponRedeem
  extends VuexModule<CouponRedeemState, RootState>
  implements CouponRedeemState {
  historyDataList: any[] = [];
  @Action
  async couponExchange(variables) {
    await queryRequest({
      query: couponExchange,
      variables
    });
  }
  @Action
  async queryExchangeCouponPage({ pageInput: { pageSize, pageNum } }) {
    let res = await queryRequest({
      query: queryExchangeCouponPage,
      variables: {
        pageInput: {
          pageSize,
          pageNum
        }
      }
    });
    const { dataList = [] } = res;
    this.context.commit("setHistoryData", { data: dataList, pageNum });
    return res;
  }
  @Action
  async checkValidity(variables) {
    await queryRequest({
      query: checkValidity,
      variables
    });
  }
  @Action
  async queryByCouponCode(variables) {
    let data = await queryRequest({
      query: queryByCouponCode,
      variables
    });
    console.log(data, 99);
    return data;
  }

  @Mutation
  cleanHistoryData() {
    this.historyDataList = [];
  }
  @Mutation
  setHistoryData({ data, pageNum }) {
    const filterData = data.map(({ node }) => {
      return { ...node, show: false };
    });
    this.historyDataList =
      pageNum === 1 ? filterData : [...this.historyDataList, ...filterData];
  }
}
